// extracted by mini-css-extract-plugin
export var actionButton = "_71-1";
export var actionButtons = "_71-2";
export var actions = "_71-0";
export var aiUnread = "_71-10";
export var alignCenter = "_71-h";
export var backWrapper = "_71-3";
export var cellContainer = "_71-4";
export var checkboxContainer = "_71-5";
export var contentContainer = "_71-6";
export var contentHeader = "_71-8";
export var conversationsTableWrapper = "_71-s";
export var draftReplyBadgeContainer = "_71-m";
export var dropdownItem = "_71-b";
export var dropdownItemsContainer = "_71-a";
export var dropdownTitle = "_71-c";
export var errorIcon = "_71-7";
export var filter = "_71-d";
export var gray = "_71-i";
export var headerActionButtons = "_71-e";
export var headerCheckboxContainer = "_71-f";
export var icon = "_71-j";
export var menuContainer = "_71-k";
export var noMoreTicketsIcon = "_71-12";
export var noMoreTicketsSubText = "_71-13";
export var oneLine = "_71-l";
export var optionsButton = "_71-n";
export var plus = "_71-o";
export var portalButtonsWrapper = "_71-g";
export var red = "_71-p";
export var scrolledTop = "_71-9";
export var search = "_71-q";
export var selectedConversationsCount = "_71-r";
export var spinner = "_71-t";
export var strong = "_71-u";
export var summaryCell = "_71-v";
export var tableContainer = "_71-11";
export var tagContainer = "_71-w";
export var threeDots = "_71-x";
export var twoLines = "_71-y";
export var unread = "_71-z";